module.exports = __webpack_public_path__ + "assets/img/Callander-Cricket-Club.f6e71608.png";